import { createRoute } from '@tanstack/react-router'
import { authenticatedRoute } from '../_authenticated'
import { Settings } from '@/pages/settings'

export const settingsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/settings',
  component: Settings,
})
